import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../utils";
import { useAuthHeaders } from "../../components/Token";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import { WithContext as ReactTags } from "react-tag-input";
import Dropzone from "react-dropzone";
import { useParams } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import { DatePicker } from "antd";
const EditNewProducts = () => {
  const { id } = useParams();
  const [propertyTitle, setPropertyTitle] = useState("");
  const [images, setImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [location, setLocation] = useState("");
  const [totalArea, setTotalArea] = useState("");
  const [propertyFacing, setPropertyFacing] = useState("");
  const [price, setPrice] = useState("");
  const [address, setAddress] = useState("");
  const [categories, setCategories] = useState([]);
  const [propertyCode, setPropertyCode] = useState("");
  const headers = useAuthHeaders();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [featureProperty, setFeatureProperty] = useState("");
  const [type, setSubmitCategory] = useState("");
  const [propertyType, setSubmitSubCategory] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [propertyDescription, setPropertyDescription] = useState("");
  const [seoKeywords, setSeoKeywords] = useState([]);
  const [seoDescription, setSeoDescription] = useState("");
  const [seoTitle, setSeoTitle] = useState("");
  const [locationmap, setLocationmap] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showCalendaracution, setShowCalendaracution] = useState(false);
  const [inspection_date, setInspection_date] = useState("");
  const [auction_date, setAuction_date] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const navigate = useNavigate();
  const KeyCodes = {
    comma: 188,
    enter: 13,
  };
  const delimiters = [KeyCodes.comma, KeyCodes.enter];

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    files.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState == 2) {
          setPreviewImages((oldArray) => [...oldArray, reader.result]);
          setImages((oldArray) => [...oldArray, file]);
        }
      };

      reader.readAsDataURL(file);
    });
  };
  const onDrop = (acceptedFiles) => {
    // Limiting to a maximum of 10 images

    if (images.length + acceptedFiles.length <= 10) {
      setImages([...images, ...acceptedFiles]);
    } else {
      alert("You can upload a maximum of 10 photos");
    }

    const files = Array.from(acceptedFiles.target.files);

    files.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState == 2) {
          setPreviewImages((oldArray) => [...oldArray, reader.result]);
          setImages((oldArray) => [...oldArray, file]);
        }
      };

      reader.readAsDataURL(file);
    });
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/property/getproperty/${id}`)
      .then((response) => {
        console.log(response, "cccccccccccccccccccccccccccccccccccccccc");

        const property = response?.data?.data;
        // console.log(
        //   property.ownerDetails.name,
        //   "Propertys valuesssssssssssssssssssssssssssss"
        // );

        setPropertyTitle(property?.propertyTitle);
        setSubmitCategory(property?.type);
        setLocation(property?.location || "");
        console.log("value is present in owner deatils ");
        setTotalArea(property?.totalArea || "");
        setFeatureProperty(property?.featureProperty);
        setSubmitSubCategory(property?.propertyType);
        setPropertyFacing(property?.propertyFacing || "");
        setPrice(property?.price || "");
        setAddress(property?.address || "");
        setLocationmap(property.locationmap || "")
        setInspection_date(property.inspection_date || "");
        setAuction_date(property.auction_date || "")
        setCategories(property?.categories || []);
        setPropertyCode(property?.propertyCode || "");
        setSubCategory(property?.subCategory || []);
        setPropertyDescription(property?.propertyDescription || "");
        setSeoTitle(property?.seoDetails?.seoTitle);
        setSeoDescription(property?.seoDetails?.seoDescription);
        // setSeoKeywords(property?.seoDetails?.seoKeywords);
        setName(property?.ownerDetails?.name);
        setEmail(property?.ownerDetails?.email);
        setMobile(property?.ownerDetails?.mobile);
        
        setImages(property?.propertyImages);
        // console.log(property.propertyImages,"SCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCFFFFFFFFFFFFF")
        console.log("value is present in owner deatils ");
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const formData = new FormData();

  //   const data = {
  //     propertyType: propertyType,
  //     propertyTitle: propertyTitle,
  //     location: location,
  //     type: type,
  //     totalArea: totalArea,
  //     featureProperty: featureProperty,
  //     propertyFacing: propertyFacing,
  //     propertyCode: propertyCode,
  //     price: price,
  //     address: address,
  //     propertyDescription: propertyDescription,
  //     seoTitle: seoTitle,
  //     seoDescription: seoDescription,
  //     seoKeywords: seoKeywords.map((tag) => (typeof tag === 'string' ? tag : tag.text)).join(",").trim(),
  //     email: email,
  //     name: name,
  //     mobile: mobile,
  //   };
  //   images.forEach((image) => {
  //     formData.append("propertyImages", image);
  //     console.log(image, "images");
  //   });
  //   axios
  //     .put(`${API_BASE_URL}/property/properties/${id}`, data, {
  //       headers,
  //     })
  //     .then((response) => {
  //       console.log("Property updated ssssss:", response);
  //       Swal.fire({
  //         icon: "success",
  //         title: "Success!",
  //         text: "Property updated successfully.",
  //       });
  //       // Optionally, you can redirect or perform any other action after update
  //     })
  //     .catch((error) => {
  //       console.error("Error updating property:", error);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: error.response?.data?.error || "An error occurred",
  //       });
  //     });
  // };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    // formData.append("auction_date", auction_date);
    // formData.append("inspection_date", inspection_date);
    // formData.append("locationmap", locationmap);
    const data = {
      propertyType: propertyType,
      propertyTitle: propertyTitle,
      location: location,
      type: type,
      totalArea: totalArea,
      featureProperty: featureProperty,
      propertyFacing: propertyFacing,
      propertyCode: propertyCode,
      price: price,
      address: address,
      propertyDescription: propertyDescription,
      seoTitle: seoTitle,
      seoDescription: seoDescription,
      auction_date: auction_date,
      inspection_date: inspection_date,
      locationmap: locationmap,

      // seoKeywords: seoKeywords
      //   .filter(tag => tag.text !== undefined)
      //   .map(tag => tag.text.trim())
      //   .join(","),
      email: email,
      name: name,
      mobile: mobile,
    };

    images.forEach((image) => {
      formData.append("propertyImages", image);
      console.log(image, "images");
    });

    axios
      .put(`${API_BASE_URL}/property/properties/${id}`, data, {
        headers,
      })
      .then((response) => {
        console.log("Property updated ssssss:", response);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Property updated successfully.",
        });
        navigate("/PropertyView");
        // Optionally, you can redirect or perform any other action after update
      })
      .catch((error) => {
        console.error("Error updating property:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.error || "An error occurred",
        });
      });
  };

  const handleDeletes = (i) => {
    setSeoKeywords(seoKeywords.filter((tag, index) => index !== i));
  };

  const handleAddition = (tag) => {
    setSeoKeywords([...seoKeywords, tag]);
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = [...seoKeywords];
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    setSeoKeywords(newTags);
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/getallcategory`, { headers })
      .then((response) => {
        setCategories(response?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);

  const handleCategorySelect = (e) => {
    const selectedCategory = e.target.value;
    setSelectedCategory(selectedCategory);
    const findCategoryName = categories.find(
      (cat) => cat._id === selectedCategory
    );
    setSubmitCategory(findCategoryName.categoryname);

    axios
      .get(`${API_BASE_URL}/getsubcategorybycategory/${selectedCategory}`, {
        headers,
      })
      .then((response) => {
        console.log(response, "DSSSSSSSSSSSSSSSSSSSSSSSSS");
        setSubCategory(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching subcategory data:", error);
      });
  };

  const handleSubCategorySelect = (e) => {
    const selectedSubCategory = e.target.value;
    setSelectedSubCategory(selectedSubCategory);
    const findCategoryName = subCategory.find(
      (cat) => cat._id === selectedSubCategory
    );
    setSubmitSubCategory(findCategoryName.subcategoryname);
  };
  const handleDelete = (i) => {
    setImages(images.filter((_, index) => index !== i));
    setPreviewImages(previewImages.filter((_, index) => index !== i));
  };

  return (
    <div className="container bg-white ">
      <h4 className="text-center p-3 fw-light">Edit Property</h4>
      <form onSubmit={handleSubmit}>
        <div className="row mt-2 d-flex">
          <div className="col-md-6">
            <div className="form-group">
              <label className="label fw-light">Property Title</label>
              <input
                type="text"
                value={propertyTitle}
                onChange={(e) => setPropertyTitle(e.target.value)}
                className="input"
                required
              />
            </div>

            <div className="form-group">
              <label className="label fw-light">Location</label>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="input"
                required
              />
            </div>

            <div className="form-group">
              <label className="label fw-light">Type</label>
              <Form.Select
                id="category"
                aria-label="Default select example"
                className="my-2"
                required
                value={selectedCategory}
                onChange={handleCategorySelect}
              >
                <option value="">Select a Type </option>
                {categories.map((category) => (
                  <option key={category?._id} value={category?._id}>
                    {category?.categoryname}
                  </option>
                ))}
                {console.log(categories, "SSSSSSSSSSS")}
              </Form.Select>
            </div>

            <div className="form-group">
              <label className="label fw-light">Property Type</label>
              <Form.Select
                id="subCategory"
                aria-label="Default select example"
                className="my-2"
                required
                value={selectedSubCategory}
                onChange={handleSubCategorySelect}
              >
                <option value="">Select a Type Property</option>
                {subCategory.map((category) => (
                  <option key={category?._id} value={category?._id}>
                    {category?.subcategoryname}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="form-group ">
              <label className="label fw-light">Total Area</label>
              <input
                type="text"
                value={totalArea}
                onChange={(e) => setTotalArea(e.target.value)}
                className="input"
                required
              />
            </div>
            <div className="row">
            <div className="col">

          <div>
              <Form.Check
                type="switch"
                id="custom-switch"
                label="Inspection Date"
                checked={showCalendar} // Bind to state
                onChange={() => setShowCalendar(!showCalendar)} // Handle change event
              />
              {showCalendar && (
                <div className="mt-3">
                  <label>Select a Date:</label> <br />
                  <DatePicker
                    selected={inspection_date}
                    onChange={(date) => setInspection_date(date)} // Update selected date
                    inline // Shows the calendar inline
                  />
                </div>
              )}
            </div>
            </div>
            <div className="col">
            <div>
              <Form.Check
                type="switch"
                id="custom-switch"
                label="Auction Date"
                checked={showCalendaracution} // Bind to state
                onChange={() => setShowCalendaracution(!showCalendaracution)} // Handle change event
              />
              {showCalendaracution && (
                <div className="mt-3">
                  <label>Select a Date:</label> <br />
                  <DatePicker
                    selected={auction_date}
                    onChange={(date) => setAuction_date(date)} // Update selected date
                    inline // Shows the calendar inline
                  />
                </div>
              )}
            </div>
            </div>
          </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label className="label fw-light">Property Facing</label>
              <input
                type="text"
                value={propertyFacing}
                onChange={(e) => setPropertyFacing(e.target.value)}
                className="input"
                required
              />
            </div>
            <div className="form-group">
              <label className="label fw-light">Property Code</label>
              <input
                type="text"
                value={propertyCode}
                onChange={(e) => setPropertyCode(e.target.value)}
                className="input"
                required
              />
            </div>
            <div className="form-group">
              <label className="label fw-light">Feature Property</label>
              <input
                type="text"
                value={featureProperty}
                onChange={(e) => setFeatureProperty(e.target.value)}
                className="input"
                required
              />
            </div>
            <div className="form-group">
              <label className="label fw-light">Price</label>
              <input
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="input"
                required
              />
            </div>

            <div className="form-group">
              <label className="label fw-light">Address</label>
              <input
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="input"
                required
              />
            </div>

            {/* <Dropzone onDrop={onDrop}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps({ className: "dropzone" })}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              )}
            </Dropzone>

            <div className="preview-images">
              {previewImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`preview ${index}`}
                  className="preview-image"
                />
              ))}
            </div>
          </div> */}
          
            <div className="form-group">
              <label className="label fw-light">Property Images (Max 10)</label>
              <Dropzone onDrop={onDrop}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()} className="dropzone">
                    <input
                      {...getInputProps()}
                      type="file"
                      onChange={handleFileChange}
                      multiple
                    />
                    <p>
                      Drag 'n' drop some files here, or click to select files
                    </p>
                  </div>
                )}
              </Dropzone>

              <div className="images-preview">
                {console.log(images, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFf")}
                {images &&
                  images.map((file, index) => {
                    const files = file.propertyImage;

                    return (
                      <>
                        <img
                          key={index}
                          src={files}
                          alt={`Uploaded ${index}`}
                          className="image-preview"
                          onLoad={() => files}
                        />

                        <span
                          className="ReactTags__remove"
                          onClick={() => handleDelete(index)}
                        >
                          <RxCross2 />
                        </span>
                      </>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="label">Location </label>
          <input
            type="text"
            value={locationmap}
            onChange={(e) => setLocationmap(e.target.value)}
            className="input"
            placeholder="Enter your loaction link"
            required
          />
        </div>
        <div className="form-group">
          <label className="label fw-light">Property Description</label>
          <ReactQuill
            theme="snow"
            value={propertyDescription}
            onChange={(value) => setPropertyDescription(value)}
            required
            className="input "
          />
        </div>
        <div>
          <h4 className="fw-light">Seo Details</h4>

          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="label fw-light">SEO Title</label>
                <input
                  type="text"
                  value={seoTitle}
                  onChange={(e) => setSeoTitle(e.target.value)}
                  className="input"
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group ">
                <label className="label fw-light">SEO Keywords</label>
                <ReactTags
                  tags={seoKeywords}
                  delimiters={delimiters}
                  handleDelete={handleDeletes}
                  handleAddition={handleAddition}
                  handleDrag={handleDrag}
                  inputFieldPosition="inline"
                  editable
                  placeholder="Add new keyword"
                  className="input"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="label fw-light">SEO Description</label>
                <input
                  type="text"
                  value={seoDescription}
                  onChange={(e) => setSeoDescription(e.target.value)}
                  className="input"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          Owner Details
          <h4></h4>
          <div className="row ">
            <div className="col-md-4">
              <div className="form-group">
                <label className="label fw-light">Contact Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="input"
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group ">
                <label className="label fw-light">Contact Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input"
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="label fw-light">Contact Mobile</label>
                <input
                  type="text"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  className="input"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <button className="btn btn-primary m-auto" type="submit">
          Update
        </button>
      </form>
    </div>
  );
};

export default EditNewProducts;
